module.exports = __webpack_public_path__ + "img/op_home-personas-1.b03adab.jpg";